module.exports = __webpack_public_path__ + "img/feature-6-2.2c8cbdfe.png";